import { createFeatureSelector, createSelector } from "@ngrx/store";
import { InvoicesState, invoiceFeatureKey } from "./invoices.reducers";

const selectFeature = createFeatureSelector<InvoicesState>(
  invoiceFeatureKey
);

export const selectAllInvoices = createSelector(
  selectFeature,
  (state) => Object.values(state.entities)
);

export const selectInvoiceEntities = createSelector(
  selectFeature,
  (state) => state.entities
);

export const selectInvoiceById = (id: number) =>
  createSelector(
    selectInvoiceEntities,
    (entities) => entities[id]
  );

export const selectInvoicesByStudentId = (studentId: number) =>
  createSelector(
    selectInvoiceEntities,
    (entities) => Object.values(entities).filter(
      (invoice) => invoice?.student_id === studentId
    )
  );

export const selectIsLoaded = createSelector(
  selectFeature,
  (state) => state.areInvoicesLoaded
);

export const selectIsLoading = createSelector(
  selectFeature,
  (state) => state.isLoading
)

export const selectSelectedInvoice = createSelector(
    selectFeature,
    (state) => {
      const selectedInvoiceId = state.selectedInvoice;
      return selectedInvoiceId ? state.entities[selectedInvoiceId] : null;
    }
);

export const selectNewInvoiceItems = createSelector(
  selectFeature,
  (state) => state.newInvoiceItems
);

export const selectIsVisible = createSelector(
  selectFeature,
  (state) => state.isVisible
);

export const selectInvoiceFilter = createSelector(
  selectFeature,
  (state) => state.invoiceFilter || "Offen"
);
